import React from 'react';
import { VinculaLiveEditor } from '../live/VinculaLiveEditor';
import type { StudioLiveEditorProps } from '../types/editor.types';

export function VinculaBuilder(props: StudioLiveEditorProps) {
  return <VinculaLiveEditor {...props} />;
}
